import cx from 'classnames'
import React from 'react'

import { isHouseRelatedType } from '@js/common/utils'

import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import ActionCardTemplate from '@f/elements/ActionCardTemplate/ActionCardTemplate'
import { HouseSizeLIcon } from '@f/elements/Icon/HouseSizeLIcon'
import { HouseSizeMIcon } from '@f/elements/Icon/HouseSizeMIcon'
import { HouseSizeSIcon } from '@f/elements/Icon/HouseSizeSIcon'
import { HouseSizeXSIcon } from '@f/elements/Icon/HouseSizeXSIcon'

interface UserBudgetProps {}

export const UserBudget = (props: UserBudgetProps) => {
  const isConversionFunnel = Boolean(props.funnelVariant)

  const handleSelection = value => {
    const detail = {}

    detail['budget_range'] = value

    window._wt({
      category: 'form',
      action: 'submit',
      location: 'modal-budget-range',
      values: [
        {
          type: 'buget_range',
          value: value
        }
      ],
      ...props.data.trackingInfo
    })

    props.actions.handleUserDataChange({
      detail,
      forcePostRequest: isHouseRelatedType(props.requestType)
    })

    props.actions.move({})
  }

  const options = [
    {
      value: '200.000 - 250.000',
      CardIcon: () => (
        <HouseSizeXSIcon
          className={cx(
            'f-c-st-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'Weniger als 250.000 €'
    },
    {
      value: '350.000 - 400.000',
      CardIcon: () => (
        <HouseSizeSIcon
          className={cx(
            'f-c-st-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: '250.000 bis 400.000 €'
    },
    {
      value: '450.000 - 500.000',
      CardIcon: () => (
        <HouseSizeMIcon
          className={cx(
            'f-c-st-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: '400.000 bis 600.000 €'
    },
    {
      value: '> 600.000',
      CardIcon: () => (
        <HouseSizeLIcon
          className={cx(
            'f-c-st-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      ),
      label: 'Mehr als 600.000 €'
    }
  ]

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}
      data-wtloc='modal-budget-range'>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Wie viel wollen Sie ungefähr für Ihr Haus ohne Grundstück ausgeben?
          </div>
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-overflow ]'>
            <div className='RequestWizard-options-wrapper'>
              {options.map(option => (
                <QuestionRadioButton
                  key={option.value}
                  wtData={{
                    location: 'modal-budget-range',
                    flow_information: props.data.trackingInfo.flow_information
                  }}
                  onClick={() => handleSelection(option.value)}>
                  <ActionCardTemplate
                    sizeActionCard={isConversionFunnel ? 'large' : undefined}
                    {...option}
                  />
                </QuestionRadioButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
